module.exports = __webpack_public_path__ + "img/banner_estimate.15e4aeef.jpg";